import React, { VFC } from 'react';

import { OrderSummary } from 'components/product-detail/order-summary';
import { PickerAspects } from 'components/product-detail/picker-aspects';
import { MenuObjectTypes } from 'enums/menu';
import { useProductWizardContext } from 'state/product-wizard';
import { useFlag } from 'utils/launchdarkly';

import { ProductUpsell } from '../product-upsell';

import { ProductSelectionsContainer } from './product-home.styled';

export interface IProductHomeProps {
  showStaticPickers?: boolean;
}

/**
 * The summary of the Product Wizard.
 * NOTE: this component is rendered on the DOM even when the user is viewing another step on the wizard.
 * Do not rely on unmount principles, because it does not get unmounted.
 * The fixed buttons in mobile are removed to avoid collisions with overlays.
 */
export const ProductHome: VFC<IProductHomeProps> = ({ showStaticPickers }) => {
  const { menuObject, userSelections, isSimplyOffer } = useProductWizardContext();
  const userSelectedPickerAspects = userSelections.pickerAspects;

  const useEnableMenuUpsellItems = useFlag('enable-menu-upsell-items');

  return (
    <>
      <ProductSelectionsContainer testID="product-home-customization-panel">
        {menuObject._type === MenuObjectTypes.PICKER && (
          <PickerAspects
            pickerData={menuObject}
            userSelectedPickerAspects={userSelectedPickerAspects}
          />
        )}
        {!showStaticPickers && <OrderSummary />}
      </ProductSelectionsContainer>
      {!isSimplyOffer && useEnableMenuUpsellItems && !showStaticPickers && <ProductUpsell />}
    </>
  );
};

export default ProductHome;
